import React, { FC, useRef, useEffect, useState, memo } from 'react';
import * as eCharts from 'echarts';
import { lineTooltipFormatter } from './linechart';
import { set, cloneDeep, get } from 'lodash-es';
import { useIntl } from 'umi';

const xAxisList = ['D2', 'D3', 'D7', 'D15', 'D31'];

interface RetentionCurveProps {
  gameRetentionList: { [key: string]: any }[];
  gassGameNum: number
}

const RetentionCurve: FC<RetentionCurveProps> = (props) => {
  let myChart: any = null;
  const { gameRetentionList, gassGameNum } = props;
  const chartRef = useRef(null);
  const [options, setOptions] = useState<any>();
  const { formatMessage } = useIntl();

  useEffect(() => {
    let selectedConfig: any = {};
    let gameListSeries: any[] = [];
    gameRetentionList?.forEach((item, index) => {
      gameListSeries.push({
        name: item?.name,
        type: 'line',
        showSymbol: false,
        symbolSize: 10,
        symbol: 'circle',
        emphasis: {
          itemStyle: {
            borderWidth: 1,
            borderColor: '#fff',
          },
        },
        data:
          item?.curve_metrics?.map((config: any) => ({
            value: config?.metric_value,
            level: config?.metric_rate,
            cover: item?.cover,
          })) || [],
      });
      selectedConfig[item.name] = index <= 5;
    });
    const gameLineOptions = {
      grid: {
        top: 12,
        bottom: 30,
        left: 0,
        right: 0,
        containLabel: true,
      },
      legend: {
        show: true,
        selected: selectedConfig,
        type: 'scroll',
        orient: 'horizontal',
        pageIconColor: '#000',
        selectedMode: true,
        pageIconSize: 13,
        pageTextStyle: {
          color: '#000',
        },
        icon: 'circle',
        itemWidth: 8,
        itemHeight: 8,
        bottom: -4,
        left: 'center',
      },
      tooltip: {
        confine: true,
        trigger: 'axis',
        showDelay: 10,
        hideDelay: 100,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        extraCssText: 'border: none;',
        padding: 0,
        axisPointer: {
          z: 0,
          label: {
            show: true,
            color: '#3B3D4B',
            backgroundColor: '#FFF',
          },
          lineStyle: {
            color: '#BBBDCB',
            type: 'solid',
          },
        },
        formatter: (param: any) => {
          return lineTooltipFormatter(
            param?.sort((a: any, b: any) => b?.value - a?.value),
            param[0]?.axisValue,
            formatMessage({ id: 'dbi_benchmark_retention' }),
            (value: any, target: any) => `${value?.toFixed(2)}%`,
          );
        },
      },
      xAxis: {
        type: 'category',
        data: xAxisList,
        axisLine: {
          lineStyle: {
            color: '#BFBFBF',
          },
        },
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: '#BFBFBF',
            width: 1,
          },
        },
        boundaryGap: true, // 不留白，从原点开始
      },
      yAxis: {
        type: 'value',
        // max: 100,
        axisLine: {
          show: false,
          lineStyle: {
            color: '#BFBFBF',
          },
        },
        axisLabel: {
          formatter: '{value}%',
          show: true,
        },
      },
      series: gameListSeries,
    };

    setOptions(gameLineOptions);
  }, [gameRetentionList]);

  const handleResize = () => {
    try {
      myChart.resize();
    } catch (err) {}
  };

  useEffect(() => {
    if (myChart === null) {
      myChart = eCharts.init(chartRef!.current!);
    }
    options && myChart.setOption(options);

    myChart.on('legendselectchanged', (params: any) => {
      const selectedConfig = cloneDeep(params.selected);
      const selectedList = Object.values(params.selected).filter(
        (item) => item,
      );
      const gameOptions = cloneDeep(options);
      if (selectedList.length > 10) {
        set(selectedConfig, `${params.name}`, false);
        set(gameOptions, `legend.selected`, selectedConfig);
        setOptions(gameOptions);
      }
    });
    return () => {
      myChart.off('legendselectchanged');
    };
  }, [options]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myChart]);

  return <div ref={chartRef} style={{ height: gassGameNum >20? 445: 425, width: '100%' }}></div>;
};

RetentionCurve.defaultProps = {};

export default memo(RetentionCurve);
